import {
  BoxProps, Flex, HStack, Icon, Text,
} from "@chakra-ui/react";
import { dateInFormat, DEFAULT_TIME_FORMAT } from "helpers/time";
import { errorStyles, greenStyles, orangeStyles } from "components/Tag/Status/styles";
import { PropsWithChildren } from "react";
import CaminoAlertIcon from "components/Icon/CaminoAlertIcon";

export default function ScheduledAtTag({
  scheduledAt,
  timezone,
  durationMinutes,
  status,
  children,
  ...rest
}: PropsWithChildren & BoxProps & {
  scheduledAt?: string;
  timezone: string;
  durationMinutes: number;
  status?: string;
}) {
  const textProps = { fontSize: 12 };
  const isCancelled = status === "cancelled";

  const getContainerProps = () => {
    if (isCancelled) return errorStyles;
    if (scheduledAt) return greenStyles;
    return orangeStyles;
  };

  const containerProps = getContainerProps();

  return (

    <Flex
      alignItems="center"
      justifyContent="space-between"
      borderRadius="md"
      px={2}
      py={1}
      {...rest}
      {...containerProps}
    >
      {scheduledAt ? (
        <Text {...textProps}>
          {isCancelled && (
            <Text as="span" fontWeight="bold">
              {"Cancelled  "}
            </Text>
          )}
          <Text as="span">
            {isCancelled ? "The meeting was Scheduled for " : "Scheduled "}
          </Text>
          <Text as="span" fontWeight="bold">
            {!isCancelled && "on "}
            {dateInFormat(scheduledAt, `MMM Do, YYYY [at] ${DEFAULT_TIME_FORMAT}`, timezone)}
            {` (${durationMinutes} minutes)`}
          </Text>
        </Text>
      ) : (
        <HStack spacing={1}>
          <Icon as={CaminoAlertIcon} />
          <Text {...textProps}>
            Not Scheduled
          </Text>
        </HStack>
      )}
      {children}
    </Flex>
  );
}
